<template>
    <div class="signal_template" :style="screenHeight">
      <div class="fixed_search">
        <div class="fixed_search_input">
          <Input v-model="pingIp" placeholder="请输入注册地址" title="注册地址"/>
        </div>  
        <div class="fixed_search_input">
          <Input v-model="localIp" placeholder="请输入本机IP地址" title="本机IP地址"/>
        </div> 
        <div class="fixed_search_input compare_select">
          <Select v-model="compareAvg"  clearable title="选择平均时延">
            <Option v-for="(option, index) in signalaverageList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>
          <Input v-model="pingAvg" placeholder="平均时延" title="平均时延"/>
        </div>
        <div class="fixed_search_input compare_select">
          <Select v-model="compareRate"  clearable title="选择丢包率">
            <Option v-for="(option, index) in plrList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>
          <Input v-model="pingRate" placeholder="丢包率" title="丢包率"/>
        </div>
        <div class="date_input fixed_search_input">
          <el-date-picker v-model="createTime" :clearable="false" unlink-panels type="datetimerange" start-placeholder="开始时间" end-placeholder="结束时间" align="left" :default-time="['00:00:00', '23:59:59']"  :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </div>
        <div class="fixed_operation_btn">
          <Button type="primary" @click="initSearch()">查询</Button>
        </div>
        <Tooltip class="tips_font" placement="bottom">
                    <div slot="content">
                        <p>1、ping平均时延<=30ms信号好,图标满格绿色</p>
                        <p>2、30 ms< ping平均时延<= 50ms 信号中等,图标4格黄色 </p>
                        <p>3、ping平均时延 > 50ms 或 丢包率 > 0%,信号差,图标2格红色</p>
                        <p>4、无法ping通,网络不通,无信号,图标灰色</p>
                    </div>
                   <img :src="questionMark" style="margin-top:10px"/>
        </Tooltip>

      </div>
      
      <div class="fixed_table">
      <Spin size="large" fix v-if="spinShow"> <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <div class="table_head">
        <table>
          <tr>
            <th class="font_style_set" style="width:5%;">序号</th>
            <th class="font_style_set" style="width:19%;">注册地址</th>
            <th class="font_style_set" style="width:19%;">本地IP地址</th>
            <th class="font_style_set" style="width:19%;">平均时延</th>
            <th class="font_style_set" style="width:19%;">丢包率</th>
            <th class="font_style_set" style="width:19%;">时间</th>
          </tr>
        </table>
      </div>
      <div class="footer_style" :style="tableHeight">
        <table class="table_head_footer">
          <!-- <tr v-for="(item , index) in contentList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}"> -->
          <tr v-for="(item , index) in contentList" :key="index" :id="item.id" v-bind:style="setStyle(item.pingAvg,item.pingRate)">
            <td style="width:5%;">{{index+1}}</td>
            <td style="width:19%;">{{item.pingIp}}</td>
            <td style="width:19%;">{{item.localIp}}</td>
            <td style="width:19%;">{{item.pingAvg}}</td>
            <td style="width:19%;">{{item.pingRate}}</td>
            <td style="width:19%;">{{item.createTime}}</td>
          </tr>
        </table>
      </div>
      <div class="page_style">
        <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
        <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
      </div>
     </div>
      
    </div>

</template>
<script>
import {publicFunClass} from '@/components/js/PublicFunClass.js'
export default {
    name: "signalpage",
    mixins:[publicFunClass],
    props:{
      pageCode:String
    },
    data(){
      return {
        showPageCount:0,
        screenHeight:{height:''},
        tableHeight:{height:''},
        total:0,
        pageSizeList:[10,20,30,40,50,100,200],
        currentPage:1,
        pageSize:20,
        speedChangePage: 1,
        spinShow:true,
        editable:false,

        pingIp:'',
        localIp:'',

        compareAvg:'',
        signalaverageList:[{'id':'>','name':'大于'},{'id':'=','name':'等于'},{'id':'<','name':'小于'},{'id':'>=','name':'大于等于'},{'id':'<=','name':'小于等于'}],
        pingAvg:'',
        compareRate:'',
        plrList:[{'id':'>','name':'大于'},{'id':'=','name':'等于'},{'id':'<','name':'小于'},{'id':'>=','name':'大于等于'},{'id':'<=','name':'小于等于'}],
        pingRate:'',
        createTime:[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')],

        tableClass: true,
        contentList: [],
        fieldList: [
          {key:'index','title':'序号'},{key:'pingIp','title':'注册地址'},{key:'localIp','title':'本机ip地址'},{key:'pingAvg','title':'平均时延'},
          {key:'pingRate','title':'丢包率'},{key:'createTime','title':'时间'}
        ],
        questionMark:require('../../assets/image/homeAsk.png'),
      }
    },
    methods:{

      initSearch:function () {
        let reg=/^[0-9]+.?[0-9]*/;
        if(!reg.test(this.pingAvg)&&this.pingAvg!=""){
          this.$Message.info("请输入正确的平均时延格式(数字)");
          return false;
        }
        if(!reg.test(this.pingRate)&&this.pingRate!=""){
          this.$Message.info("请输入正确的丢包率格式(数字)");
          return false;
        }
        this.spinShow=true;
        this.$emit("closeVn",true);
        let that=this;
        let param={
          pageNum:this.currentPage,
          pageSize:this.pageSize,
          pingIp:this.pingIp,
          localIp:this.localIp,
          compareAvg:this.compareAvg,
          pingAvg:parseInt(this.pingAvg),
          compareRate:this.compareRate,
          pingRate:parseInt(this.pingRate),
          createTime:this.createTime.length==0?"":this.createTime.toString(),
        };
        this.$http.post("pingRecord/toIndex.json",param) .then(function (res) {
            let result=res.data.flag;
            that.spinShow=false;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.total=res.data.obj.list.totalSize;
            that.contentList=res.data.obj.list.content;
        });
      },
       reset:function(){
        this.pingIp="";
        this.localIp="";
        this.compareAvg="";
        this.pingAvg="";
        this.compareRate="";
        this.pingRate="";
        this.createTime="";
      },
      setStyle(avg,rate){ 
        let avgcolor=parseInt(avg);
        let ratecolor=parseInt(rate);
                if(ratecolor>0&&ratecolor<100){
                     return 'background:#fcbcbc'
                }else if(avgcolor>0 && avgcolor<=30){
                       return 'background:#bdfdcc'
                }else if(avgcolor > 30 && avgcolor <= 50){
                       return 'background:#fdf6c5'
                }else if(avgcolor > 50){
                       return 'background:#fcbcbc'
                }else if(ratecolor==100||avgcolor==0){
                      return 'background:#e6e6e6'
                }
      }
    },
    created(){
      this.tableHeight.height=this.tableHeight.height=this.mountHeight(222);
    },
    watch:{
      pageCode:function () {
        if(this.pageCode=='signal' && this.showPageCount==0){
          this.showPageCount++;
          this.initSearch();
        }
      }
    },
    
}
</script>


// WEBPACK FOOTER //
// src/components/myWorkbench/signalpage.vue